import { gql } from "@apollo/client";

export const APP_DETAIL_QUERY = gql`
  query developerAppDetail($id: ID!) {
    marketplaceApp(id: $id) {
      id
      organizationAppId
      name
      shortDescription
      description
      icon
      screenshots
      categories
      version
      status
      manifest {
        version
        permissions
        webhookEvents
        metafieldNamespaces
        extensions {
          type
          label
          activePages
        }
        frontendModules {
          name
          displayName
          description
          exportName
        }
      }
      pricing {
        id
        type
        priceAmountCents
        currency
        trialDays
        createdAt
        updatedAt
      }
      stats {
        totalInstallations
        averageRating
        totalReviews
      }
      reviews(page: { first: 10 }) {
        nodes {
          id
          rating
          title
          body
          createdAt
        }
        totalCount
      }
      privacyPolicyUrl
      supportUrl
      websiteUrl
      createdAt
      updatedAt
    }
  }
`;

export const ORG_APP_QUERY = gql`
  query developerOrgApp($id: String!) {
    organizationApp(id: $id) {
      id
      name
      description
      shortDescription
      icon
      public
      creatorId
      creator {
        id
        email
      }
      configuration {
        name
        redirectUrls
        logoutRedirectUrls
        scope
        metadata {
          loginUrl
          consentUrl
          public
          requiresConsent
        }
      }
      appWebhooks {
        id
        url
        events
        active
        organizationId
        installationId
        createdAt
        updatedAt
      }
      releases {
        id
        version
        status
        notes
        manifest {
          version
          permissions
          extensions {
            type
            label
            activePages
          }
          frontendModules {
            name
            displayName
            description
            exportName
          }
        }
        reviewResult {
          passed
          checks {
            name
            passed
            details
          }
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const MARKETPLACE_RELEASES_QUERY = gql`
  query developerAppReleases($marketplaceAppId: ID!) {
    appReleases(marketplaceAppId: $marketplaceAppId) {
      id
      version
      status
      releaseNotes
      extensionBundleKey
      moduleBundleKey
      manifest {
        version
        permissions
        frontendModules {
          name
          displayName
        }
        extensions {
          type
          label
          activePages
        }
      }
      reviewResult {
        passed
        checks {
          name
          passed
          details
        }
      }
      reviewedAt
      createdAt
    }
  }
`;

export const UPDATE_APP_MUTATION = gql`
  mutation updateMarketplaceApp($id: ID!, $input: UpdateMarketplaceAppInput!) {
    updateMarketplaceApp(id: $id, input: $input) {
      id
      name
      status
    }
  }
`;

export const SET_PRICING_MUTATION = gql`
  mutation setMarketplaceAppPricing($input: SetMarketplaceAppPricingInput!) {
    setMarketplaceAppPricing(input: $input) {
      id
      type
      priceAmountCents
      currency
      trialDays
    }
  }
`;
